import Lang from './Languages'

export { Lang }
